<mat-menu class="mat-menu" #menu>
  <button
    mat-menu-item
    (click)="
      $event.stopPropagation();
      clippingCheckbox._inputElement.nativeElement.click()
    "
  >
    <mat-checkbox
      #clippingCheckbox
      [checked]="clippingEnabled"
      (click)="$event.stopPropagation()"
      (change)="toggleClipping($event)"
    >
      Clipping Enabled
    </mat-checkbox>
  </button>
  <div class="angle-label">Start Angle</div>
  <button
    class="slider-btn"
    mat-menu-item
    (click)="$event.stopPropagation()"
    (focus)="startingAngleSlider.focus()"
  >
    <mat-slider min="0" max="360" step="1" thumbLabel>
      <input
        #startingAngleSlider
        matSliderThumb
        [value]="startClippingAngle"
        (valueChange)="changeStartClippingAngle($event)"
      />
    </mat-slider>
    <input
      #startAngleInput
      class="angle-input"
      type="number"
      min="0"
      max="360"
      step="1"
      [value]="startClippingAngle"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (change)="changeStartClippingAngle(startAngleInput.valueAsNumber)"
    />
  </button>

  <div class="angle-label">Opening Angle</div>
  <button
    class="slider-btn"
    mat-menu-item
    (click)="$event.stopPropagation()"
    (focus)="openingAngleSlider.focus()"
  >
    <mat-slider min="0" max="360" step="1" thumbLabel>
      <input
        #openingAngleSlider
        matSliderThumb
        [value]="openingClippingAngle"
        (valueChange)="changeOpeningClippingAngle($event)"
      />
    </mat-slider>
    <input
      #openingAngleInput
      class="angle-input"
      type="number"
      min="0"
      max="360"
      step="1"
      [value]="openingClippingAngle"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (change)="changeOpeningClippingAngle(openingAngleInput.valueAsNumber)"
    />
  </button>
</mat-menu>

<app-menu-toggle
  [matMenuTriggerFor]="menu"
  tooltip="Geometry clipping"
  icon="clipping"
  [active]="clippingEnabled"
>
</app-menu-toggle>
